"use client";
import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { memo as i, forwardRef as m } from "react";
import { useSvgIcon as l } from "../useSvgIcon.js";
const p = i(
  m((t, n) => {
    const { monochrome: o, ...e } = t, s = l({
      ...e,
      ref: n
    });
    return /* @__PURE__ */ c(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s(),
        children: [
          /* @__PURE__ */ r(
            "path",
            {
              d: "M20.014 3C15.0437 3 11 7.04325 11 12.0134C11 16.9686 15.0437 21 20.014 21C24.9689 21 29 16.9686 29 12.0134C29 7.04325 24.9689 3 20.014 3Z",
              fill: o ? "var(--icon-color)" : "#FF424D"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              d: "M3 29V3H8V29H3Z",
              fill: o ? "var(--icon-color)" : "#FF424D"
            }
          )
        ]
      }
    );
  })
);
p.displayName = "IconPatreon";
export {
  p as IconPatreon
};
